import React from 'react';
import Form from './form/UserEsp';
import useUserGeneralData from './hooks/useUserGeneralData';

const AdminUserEsp = () => {
    const [data, loading, save] = useUserGeneralData();

    return (
        <>
            <Form data={data.data} loading={loading} save={save} />
        </>
    );
};

export default AdminUserEsp;
